/* eslint-disable max-len */
import React from 'react';

const Thumbnails = props => (
  <svg width={19} height={19} {...props}>
    <path
      fill="currentColor"
      d="M2 2h15a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v8h15V3H2zm6 10h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm-6 0h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm6 1v2h3v-2H8zm-6 0v2h3v-2H2zm12-1h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm0 1v2h3v-2h-3z"
    />
  </svg>
);

export default Thumbnails;
